import { Component, Input } from '@angular/core';

/*
In it.json key: "some text {{form.text:form.link}} some text"
*/
@Component({
    selector: 'app-custom-link',
    templateUrl: './custom-link.component.html',
    styleUrls: ['./custom-link.component.scss'],
    standalone: false
})
export class CustomLinkComponent {
  constructor() {}

  private _linkText!: string;
  get linkText() {
    return this._linkText;
  }
  @Input() set linkText(val: string) {
    this.setLink(val);
  }

  regex = new RegExp(/({{.+}})/);

  text!: any[];


  setLink(val: string) {
    const arrTxt: any[] = val
      .replace(this.regex, '|~|$1|~|')
      .split('|~|')
      .map((el) => {
        if (el.match(this.regex)) {
          const [text, link] = el.replace(/{{(.+)}}/, '$1').split(':');
          return { text, link };
        }
        return el;
      });
    this.text = arrTxt;
  }
}
